import { FirestoreDataConverter } from "firebase/firestore"
import { OrganisationDocument } from "../index"

export default {
    toFirestore: (organisation: OrganisationDocument) => ({
        name: organisation.name,
    }),
    fromFirestore: (snapshot, options) => {
        const organisation = snapshot.data(options)
        return {
            id: snapshot.id,
            name: organisation.name,
        }
    },
} as FirestoreDataConverter<OrganisationDocument>
